import BsjSetVehicleParametersModal from './bsj-set-vehicle-parameters-modal.vue'
export default BsjSetVehicleParametersModal
